import { createSelector } from "reselect";
import { AppState } from "src/shared/interfaces/State.interface";

const selectAuth = (state: AppState) => state.auth;

export const authentificated = () => createSelector(selectAuth, (state) => state.authentificated);
export const getActivateUserInfo = () => createSelector(selectAuth, (state) => state.activateUserInfo);
